import { render } from "./details.vue?vue&type=template&id=207af048&scoped=true&ts=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=207af048&lang=scss&scoped=true"

import exportComponent from "/Users/wangzicheng/Documents/kaola/projectWork/kaola/project-helpCenter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207af048"]])

export default __exports__